module.exports = __webpack_public_path__ + "fonts/remixicon.888e61f0.ttf";